<template>
  <div class="about">
    <h1>This is an about page</h1><br>
    <router-link to='' @click.native="loginAndBack">Login</router-link><br>
    {{$store.getters.windowWidth}}
  </div>
</template>

<script>
  export default {
    methods: {
      loginAndBack() {
        // console.log(this.$store);
        this.$store.commit('SET_ROUTEBACK', {isBack: true, path: '/aboute'});
        // this.$store.routeBack.isBack = true;
        this.$router.push({name: 'login'});
      }
    }
  }
</script>
